import { ENVIRONMENT } from "src/environments/environment";

export const interceptorSpinnerExclusions: {url: string}[] = [
    {
      url: 'exports/commerce/3/type/CSV'
    },
    {
      url: 'exports/new'
    },
    {
      url: 'growth/events/v2'
    },
    {
      url:ENVIRONMENT.urls.fastData.api
    },
    {
      url: ENVIRONMENT.unleash.url
    },

  ];
